import React, { useState, useRef } from "react";
import {
  Badge,
  Box,
  Button,
  IconButton,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import styles from "./SearchInput.module.css";
import ReactToPrint from "react-to-print";
import ListPrintItems from "./ListPrintItems";

const CachedItems = ({ caches, handleCachedItem, type }) => {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  var printListRef = useRef;

  const handleCopyToClipboard = () => {
    const cpvData = caches.map((item) => `${item.code}`).join("\n");
    navigator.clipboard
      .writeText(cpvData)
      .then(() => {
        setSnackbarOpen(true);
      })
      .catch((err) => {
        console.error("Failed to copy text to clipboard: ", err);
      });
  };

  return (
    <>
      <Button
        variant="contained"
        className={styles["cpv-search-CachedButton"]}
        disableElevation
        onClick={() => setOpen(true)}
        disableRipple
      >
        <Badge
          badgeContent={caches?.length}
          color="warning"
          sx={{ "& .MuiBadge-badge": { fontSize: "0.55em" } }}
        >
          <FolderOpenIcon sx={{ fontSize: 40 }} />
        </Badge>
      </Button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div className={styles["cpv-search-modal"]}>
          <Box sx={{ display: "flex" }}>
            <Typography fontWeight={600} fontSize={24} flex={1} color="#0a717c">
              Ausgewählte CPV-Codes
            </Typography>
            <IconButton
              onClick={() => setOpen(false)}
              style={{ fontSize: "23px" }}
            >
              <CloseIcon sx={{ color: "#dc3545", fontSize: 23 }} />
            </IconButton>
          </Box>
          {caches?.length === 0 && (
            <Typography
              className={styles["cpv-search-empty"]}
              textAlign="left"
              color="#8a8a8a"
              my={10}
            >
              Keine CPV-Codes ausgewählt
            </Typography>
          )}
          {caches?.length > 0 && (
            <>
              <ul>
                {caches.map((item) => (
                  <li
                    key={item.code}
                    className={styles["cpv-search-listItem"]}
                  >
                    <IconButton
                      onClick={() => handleCachedItem(item)}
                      style={{ fontSize: "23px" }}
                    >
                      <DeleteIcon sx={{ color: "#dc3545", fontSize: 23 }} />
                    </IconButton>
                    <Typography
                      className={styles["cpv-search-listItemSelect"]}
                      variant="inherit"
                      sx={{ paddingTop: "6px" }}
                    >
                      <strong>{item.code}</strong>
                      {item.description}
                    </Typography>
                  </li>
                ))}
              </ul>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<ContentCopyIcon style={{ fontSize: "27px" }} />}
                  onClick={handleCopyToClipboard}
                >
                  In Zwischenablage kopieren
                </Button>
                {type !== "limitedSelect" && (
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        startIcon={<PrintIcon style={{ fontSize: "27px" }} />}
                      >
                        Drucken
                      </Button>
                    )}
                    content={() => printListRef}
                  />
                )}
              </Box>
            </>
          )}
          <div style={{ display: "none" }}>
            <ListPrintItems items={caches} ref={(el) => (printListRef = el)} />
          </div>
        </div>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="CPV-Daten erfolgreich in die Zwischenablage kopiert!"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};

export default CachedItems;
